module.exports = __webpack_public_path__ + "static/img/delu-running.b8c935a0.gif";